import { thumbnail } from '@/utils';

import * as S from './styled';

interface ThumbnailProps {
  src: string;
  alt?: string;
  size?: number;
}

export function Thumbnail({ src, alt = '', size = 40 }: ThumbnailProps) {
  return <S.ThumbnailWrapper src={thumbnail.small(src)} alt={alt} size={size} />;
}
